import React from "react";
import { StyledHelpCenterCard, StyledSnippet, StyledArticleTitle, StyledLinkButton } from "../style/support.style";

const HelpCenterCardContent = {
	id: "help",
	header: "So many questions, we couldn’t fit them all in",
	snippet: "On this page you’ll find the frequently asked questions that we come across. For more information please visit our Help Center.",
	learnMoreHref: "https://docs.fixel.ai?ref=console"
};

const HelpCenterCard = () => {
	return (
		<StyledHelpCenterCard id={HelpCenterCardContent.id}>
			<StyledArticleTitle key={HelpCenterCardContent.id + "header"}>{HelpCenterCardContent.header}</StyledArticleTitle>
			<StyledSnippet key={HelpCenterCardContent.id + "snippet"}>{HelpCenterCardContent.snippet}</StyledSnippet>
			<StyledLinkButton key={HelpCenterCardContent.id + "link"} href={HelpCenterCardContent.learnMoreHref} target="_blank" rel="noreferrer">
				Visit Help Center
			</StyledLinkButton>
		</StyledHelpCenterCard>
	);
};

export default HelpCenterCard;
